var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4309_21817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 12.5C1.81831 12.5 1.25 13.0683 1.25 13.75C1.25 14.4317 1.81831 15 2.5 15H12.5C13.1817 15 13.75 14.4317 13.75 13.75C13.75 13.0683 13.1817 12.5 12.5 12.5H2.5Z",
    fill: "#009252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.51278 11.25C7.32508 11.2544 7.14535 11.1741 7.02328 11.0315L3.27328 6.65649C2.894 6.21318 3.27507 5.53805 3.85068 5.63354L5.31489 5.87758C5.35281 5.8839 5.39166 5.88188 5.42872 5.87167C5.46579 5.86146 5.50019 5.8433 5.52952 5.81845C5.55886 5.7936 5.58243 5.76265 5.5986 5.72777C5.61476 5.69289 5.62314 5.6549 5.62314 5.61645V1.875C5.62314 0.847061 6.4702 0 7.49814 0C8.52608 0 9.37314 0.847061 9.37314 1.875V5.61645C9.37314 5.6549 9.38151 5.69289 9.39768 5.72777C9.41384 5.76265 9.43741 5.7936 9.46675 5.81845C9.49609 5.8433 9.53048 5.86146 9.56755 5.87167C9.60461 5.88188 9.64346 5.8839 9.68138 5.87758L11.1456 5.63354C11.7212 5.53805 12.1023 6.21318 11.723 6.65649L7.97299 11.0315C7.85757 11.1664 7.69026 11.2458 7.51278 11.25Z",
    fill: "#009252"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4309_21817"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.6f2213591b818c16ca4595b5b9163257.svg";
export { ForwardRef as ReactComponent };